import swal from 'sweetalert2'

const error = swal.mixin({
  title: 'An unknown error has occured.',
  icon: 'error',
  position: 'top'
})

const success = swal.mixin({
  title: 'Success!',
  icon: 'success',
  showConfirmButton: false,
  timer: 3000,
  toast: true,
  position: 'top'
})

const confirm = swal.mixin({
  title: 'Are you sure?',
  text: 'You will not be able to revert this.',
  icon: 'warning',
  showCancelButton: true
})

export const alertError = options => {
  error.fire(options)
}

export const alertSuccess = options => {
  success.fire(options)
}

export const alertConfirm = (options, confirmCallback, denyCallback) => {
  confirm.fire(options).then(confirm => {
    if (confirm.isConfirmed) {
      confirmCallback()
    } else if (denyCallback !== undefined) {
      denyCallback()
    }
  })
}
